
import Rellax from 'rellax';

export const AnimateIn = (function () {
	'use strict';

	let $win, $winH, $animateIn, $animateInGrid, threshold, distScrolled;

	var $dots;

	function init() {
		$win = $(window);
		$animateIn = $('.animate-in');
		$animateInGrid = $('.col');
		distScrolled = 0;

		initDots();
		initV2Dots();


		gsap();

		if ($animateIn.length || $animateInGrid.length) {
			resize();
			checkElements();
			$win.on('scroll', checkElements);
			$win.on('resize', resize);
		}

	}

	function getRotationDegrees(obj) {
		var matrix = obj.css("-webkit-transform") ||
			obj.css("-moz-transform") ||
			obj.css("-ms-transform") ||
			obj.css("-o-transform") ||
			obj.css("transform");
		if (matrix !== 'none') {
			var values = matrix.split('(')[1].split(')')[0].split(',');
			var a = values[0];
			var b = values[1];
			var angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
		} else { var angle = 0; }
		return (angle < 0) ? angle + 360 : angle;
	}

	function initDots() {
		$dots = $('.dot:visible');

		$dots.each(function () {

			// speed
			var speed = $(this).attr('class').replace('dot dot--', '');

			switch (speed) {
				case '1':
					speed = 3;
					break;
				case '2':
					speed = 2;
					break;
				case '3':
					speed = 1;
					break;
			}

			// offset
			var offset = $(this).offset().top;

			// rotation
			var rotation = getRotationDegrees($(this).parent()) * -1;

			// add markup
			$(this)
				.addClass('rellax')
				.attr('data-rellax-speed', speed)
				// .attr('data-offset', offset)
				// .attr('data-rotation', rotation)
				.wrap('<div style="transform: rotate(' + rotation + 'deg)"></div>');
			// .css('transform', 'rotate('+rotation+'deg)');
		});

		var rellax = new Rellax('.rellax', {
			center: 1
		});

	}


	function gsap() {

	}

	function initV2Dots() {
		$dots = $('.v2-dot:visible');

		$dots.each(function () {

			// speed
			var speed = $(this).attr('class').replace('v2-dot v2-dot--', '');

			switch (speed) {
				case '1':
					speed = 0.75;
					break;
				case '2':
					speed = 0.5;
					break;
				case '3':
					speed = 0.25;
					break;
			}

			// offset
			var offset = $(this).offset().top;

			// rotation
			var rotation = getRotationDegrees($(this).parent()) * -1;

			// add markup
			$(this)
				.addClass('rellax')
				.attr('data-rellax-speed', speed)
			// .attr('data-offset', offset)
			// .attr('data-rotation', rotation)
			// .wrap('<div style="transform: rotate('+rotation+'deg)"></div>');
			// .css('transform', 'rotate('+rotation+'deg)');
		});

		var rellax = new Rellax('.rellax', {
			center: 1
		});

		const dots = document.querySelectorAll('.v2-dot');
		// dots.forEach((dot) => {
		// 	dot.classList.add('loadin');
		// });

		const observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 0.3,
		};

		function observerCallback(entries) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('loaded');
				}
			});
		}

		const observer = new IntersectionObserver(observerCallback, observerOptions);
		dots.forEach((el) => observer.observe(el));

	}

	function resize() {
		$winH = $(window).height();
		threshold = $winH * 0.2; // this controls when the animation occurs - distance from bottom of window
	}

	function checkElements() {
		distScrolled = $win.scrollTop();

		$animateIn.each(function (i, el) {
			let $el = $(el);
			let elTreshold = $el.data('threshold') ? $(window).height() * ($el.data('threshold') / 100) : threshold;
			let elDist = $el.offset().top - ($winH - elTreshold);

			if (distScrolled > elDist) {
				$el.addClass('animated');
				$animateIn = $('.animate-in:not(.animated)');
			}
		});

		$animateInGrid.each(function (i, el) {
			let $el = $(el);
			let elTreshold = $el.data('threshold') ? $(window).height() * ($el.data('threshold') / 100) : threshold;
			let elDist = $el.offset().top - ($winH - elTreshold) - 20;

			if (distScrolled > elDist) {
				$el.addClass('animated');
				$animateInGrid = $('.col:not(.animated)');
			}
		});

	}

	return {
		init: init,
	};
})();
